import { getProductConfig } from "../registry/product-registry";
import type { Product } from "../registry/types";

/**
 * Given the current pathname, pick the registered product whose
 * `routePattern` matches. Used by the entry-source flow to decide which
 * product to start a setup row for when no `activeProduct` exists yet.
 *
 * Returns null if no product's routePattern matches. Callers fall back
 * to other strategies (existing activeProduct, first registered product).
 */
export function pickProductByRoute(
  pathname: string,
  registeredProducts: Product[],
): Product | null {
  for (const product of registeredProducts) {
    const config = getProductConfig(product);
    if (config?.routePattern.test(pathname)) {
      return product;
    }
  }
  return null;
}
